const EventStateEnum = Object.freeze({
  INACTIVE: 100,
  COMINGSOON: 8,
  UPCOMING: 1,
  PRESALE: 4,
  POSTPRESALE: 6,
  ONSALE: 3,
  SOLDOUT: 9,
  CANCELLED: 12,
  POSTPONED: 11,
  PAST: 50,
  SWEEPSTAKESUPCOMING: 2,
  SWEEPSTAKESOPEN: 5,
  SWEEPSTAKESCLOSED: 10,
  BLANK: 7
});

const EventTypeEnum = Object.freeze({
  NORMAL: 0,
  SERIES_PARENT: 1,
  SERIES_CHILD: 2,
  MP: 3
});

const PaymentTypeEnum = Object.freeze({
  PAY_CARD: 0,
  PAY_MILES: 1,
  BID_MILES: 2,
  SWEEPSTAKES: 3
});

const NagivationHighlightEnum = Object.freeze({
  NONE: 0,
  UPCOMING: 1,
  PAST: 2
});

export { EventStateEnum, EventTypeEnum, NagivationHighlightEnum, PaymentTypeEnum };
